/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import { IAddressAddItem, IAddressAddUpdateProps } from '../../common/address/components/address-add';
import { IAddressSelectItem, IAddressSelectProps } from '../../common/address/components/address-select';
import { IAddressShowItem, IAddressShowProps } from '../../common/address/components/address-show';
import { ICheckoutShippingAddressViewProps } from './citta-checkout-shipping-address';

const AddressShow: React.FC<IAddressShowProps> = ({
    AddressDetail,
    items
}) => {

    return (
        <Node {...AddressDetail}>
            {items && items.map((item: IAddressShowItem) => {
                return (
                    <>
                        {item.description}
                    </>
                );
            })}
        </Node>
    );
};

const AddressSelect: React.FC<IAddressSelectProps> = ({
    SelectAddress,
    addButton,
    items,
    isShowSaveButton,
    saveButton,
    isShowCancelButton,
    cancelButton,
    showToggleOptions
}) => {

    return (
        <div>
            {showToggleOptions}
            <Node {...SelectAddress}>
                {addButton}
                {items && items.map((item: IAddressSelectItem) => {
                    const SelectItem = item.SelectItem;
                    return (<Node {...SelectItem} key={item.key}>
                        {item.input}
                        <AddressShow  {...item.showItems} />
                    </Node>);
                })}
                {isShowSaveButton && saveButton}
                {isShowCancelButton && cancelButton}
            </Node>
        </div>
    );
};

const sortArray = (arr1: any[], arr2: any[]) => {
    arr2.sort((a, b) => {
       const aKey = a.key;
       const bKey = b.key;
       return arr1.indexOf(aKey) - arr1.indexOf(bKey);
    });
 };

const AddressAddUpdate: React.FC<IAddressAddUpdateProps> = ({
    AddressForm,
    heading,
    items,
    hasError,
    error,
    isShowSaveButton,
    saveButton,
    isShowCancelButton,
    cancelButton,
    searchAddress,
     //@ts-ignore
    countriesList
}) => {
    const order = ["Name", "ThreeLetterISORegionName",  "BuildingCompliment","StreetNumber", "Street", "DistrictName", "City", "State", "ZipCode", "Phone"]
    sortArray(order, items);
    let country: any = items.find(item => item.key === 'ThreeLetterISORegionName');
    if (countriesList && countriesList.length && country && country.input && country.input.props.displayData) {
        let res = country.input.props.displayData.filter((countryData: any) => countriesList.indexOf(countryData.key) !== -1)
        country.input.props.displayData = res;
    }

    return (
        <Node {...AddressForm}>
            {heading}
            {items && items.map((item: IAddressAddItem) => {
                const { AddressItem, key, label, alert, input } = item;
                return (<Node {...AddressItem} key={key}>
                    {label}
                    {alert}
                    {input}
                </Node>);
            })}
            {hasError && <Node {...error.AddressError}>
                {error.title}
                {error.message}
            </Node>}
            {/* {searchAddress} */}
            {isShowSaveButton && saveButton}
            {isShowCancelButton && cancelButton}
        </Node>
    );
};

const CheckoutShippingAddressView: React.FC<ICheckoutShippingAddressViewProps> = props => {
    const { selectedMode, storeName, CheckoutShippingAddress, viewState, showAddress, showAddressSelect, showAddOrUpdateAddress, showToggleOptions, deliveryNotes, clickAndCollectStores, regionAU} = props;
    const { countriesList } = props.config;
    return (
        <div>
            {showToggleOptions}
        <Module {...CheckoutShippingAddress}>
            <div className='mode'>
                {viewState.isShowAddress && selectedMode}
            </div>
            <div className='store'>
                {viewState.isShowAddress && storeName}
            </div>
            {viewState.isShowAddress  && <AddressShow {...showAddress} />  }
            {viewState.isShowAddresList && <AddressSelect {...showAddressSelect} />}
            {/* @ts-ignore */}
            {viewState.isShowAddOrUpdateAddress && <AddressAddUpdate {...showAddOrUpdateAddress} countriesList={countriesList} />}
            {clickAndCollectStores}
            {deliveryNotes}
            {regionAU}
        </Module>
        </div>
    );
};

export default CheckoutShippingAddressView;
